var app = angular.module("leonardo");

var DeleteInvitationDialog = function($scope, AccountService, PropertyService, PortfolioService) {

  if ($scope.ngDialogData.propertiesAvailable && $scope.ngDialogData.propertiesAvailable.length > 0) {
    var propertyids = [];
    angular.forEach($scope.ngDialogData.propertiesAvailable, function (property) {
      propertyids.push(property.id);
    });
    $scope.propertiesAvailable = PropertyService.getlist({disable_pagination: true, essential: true, id: (propertyids.length > 0) ? propertyids.join(',') : null}, true);
  }

  if ($scope.ngDialogData.portfoliosAvailable && $scope.ngDialogData.portfoliosAvailable.length > 0) {
    var portfolioids = [];
    angular.forEach($scope.ngDialogData.portfoliosAvailable, function(portfolio) {
      portfolioids.push(portfolio.id);
    });
    $scope.portfoliosAvailable = PortfolioService.getlist(
      { disable_pagination: true, essential: true, id: (portfolioids.length > 0) ? portfolioids.join(',') : null },
      true);
  }

  $scope.data = {
    managed_by: $scope.ngDialogData.account_to,
    account: $scope.ngDialogData.account_from
  };

  $scope.isPartial = function() {
    var partial = false;
    angular.forEach($scope.ngDialogData.propertiesAvailable, function (element) {
      if (!_.contains($scope.data.partial_dismiss_data.properties, element.id)) {
        partial = true;
      }
    });
    angular.forEach($scope.ngDialogData.portfoliosAvailable, function (element) {
      if (!_.contains($scope.data.partial_dismiss_data.portfolios, element.id)) {
        partial = true;
      }
    });
    return partial;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      return;
    }
    AccountService.get($scope.ngDialogData.account_from).then(function(data){
      if (!$scope.isPartial()) {
        data.dismiss({managed_by: $scope.ngDialogData.account_to}).then(function(){
          $scope.confirm();
        });
      }
      else {
        data.dismissPartial($scope.data).then(function(){
          $scope.confirm();
        });
      }
    });
  };
};

app.controller('DeleteInvitationDialog', ['$scope', 'AccountService', 'PropertyService', 'PortfolioService',
  DeleteInvitationDialog]);
